export const SUCCESS_GET_AVAILABILITIES = 'SUCCESS_GET_AVAILABILITIES';
export const FAILED_GET_AVAILABILITIES = 'FAILED_GET_AVAILABILITIES';


// WEBPACK FOOTER //
// ./src/state/constants/availabilityConstants.js